class StickyScrollPositionHelper {
  preserveScrollPosition = false;

  preservePositionOnce = (element) => {
    this.preserveScrollPosition = element.scrollTop;
  }

  allowFocus = () => this.preserveScrollPosition === false

  setScrollPosition = (element) => {
    if (typeof this.preserveScrollPosition === 'number') {
      element.scrollTop = this.preserveScrollPosition;
    }
  }

  resetScrollPosition = () => {
    this.preserveScrollPosition = false;
  }
}

export default new StickyScrollPositionHelper();
